export default __webpack_public_path__ + "static/media/multiplePizzas.490709e2.jpeg";